import React from 'react'
import { Link } from '@inertiajs/react'
import { CardShell } from '@/components/frontend/atoms/content/CardShell'
import { CardBody } from '@/components/frontend/atoms/content/CardBody'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { CoverImage } from '@/components/frontend/atoms/media/CoverImage'
import { Badge } from '@/components/frontend/atoms/content/Badge'
import { PostMeta } from '@/components/frontend/atoms/content/PostMeta'
import { Heading } from '@/components/frontend/atoms/typography/Heading'
import { Text } from '@/components/frontend/atoms/typography/Text'
import { ReadMoreLink } from '@/components/frontend/atoms/content/ReadMoreLink'
import { useTranslation } from '@/hooks/useTranslation'
import { readingMinutes } from '@/lib/utils'
import type { PublicPost } from '@/types/frontend'

interface BlogPostCardProps {
  post: PublicPost
}

export const BlogPostCard: React.FC<BlogPostCardProps> = ({ post }) => {
  const { t, lp } = useTranslation()
  const href = lp('/blog/' + post.slug)

  return (
    <CardShell variant="interactive">
      {post.cover_image_url && (
        <Link href={href} tabIndex={-1} aria-hidden="true">
          <CoverImage src={post.cover_image_url} alt={post.title} />
        </Link>
      )}
      <CardBody>
        <Stack gap="3">
          {post.category && <Badge tone="primary">{post.category.name}</Badge>}
          <Heading level="4" as="h3">{post.title}</Heading>
          {post.excerpt && <Text size="sm" tone="muted">{post.excerpt}</Text>}
          <PostMeta publishedAt={post.published_at} readingMinutes={readingMinutes(post.content)} />
          <ReadMoreLink href={href} label={t('blog.read_more')} />
        </Stack>
      </CardBody>
    </CardShell>
  )
}
